import styled from '@emotion/styled'

// ─────────────────────────────────────────────────────────────
// Wrapper
// ─────────────────────────────────────────────────────────────

export const SelectorWrapper = styled.div`
  position: relative;
  display: inline-block;
  width: 220px;
`

// ─────────────────────────────────────────────────────────────
// Search input trigger
// ─────────────────────────────────────────────────────────────

export const SearchInput = styled.input`
  width: 100%;

  padding: 4px 32px 4px 12px;
  height: 40px;

  border: none;
  border-radius: 12px;
  background: #dde1ea;

  color: #111827;

  font-size: 12px;
  font-weight: 600;

  cursor: ${({disabled}) => (disabled ? 'not-allowed' : 'text')};
  opacity: ${({disabled}) => (disabled ? 0.55 : 1)};

  transition: background 180ms ease, box-shadow 180ms ease;

  &::placeholder {
    color: #6b7280;
    font-weight: 500;
  }

  &:hover:not(:disabled) {
    background: #e7ebf0;
  }

  &:focus-visible {
    outline: 2px solid #2563eb;
    outline-offset: 2px;
  }
`

export const ChevronSmall = styled.span`
  position: absolute;
  top: 50%;
  right: 10px;

  display: flex;
  align-items: center;

  color: #6b7280;
  pointer-events: none;

  transform: ${({isOpen}) =>
    isOpen
      ? 'translateY(-50%) rotate(180deg)'
      : 'translateY(-50%) rotate(0deg)'};

  transition: transform 180ms ease;
`

// ─────────────────────────────────────────────────────────────
// Dropdown
// ─────────────────────────────────────────────────────────────

export const DropdownPanel = styled.div`
  position: absolute;

  top: calc(100% + 10px);
  right: 0;

  min-width: 100%;
  width: max-content;
  max-width: 320px;

  padding: 10px;

  border-radius: 16px;

  background: #ffffff;

  border: 1px solid #e5e7eb;

  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.08), 0 2px 10px rgba(0, 0, 0, 0.04);

  z-index: 1000;

  animation: dropdownEnter 0.18s ease;

  @keyframes dropdownEnter {
    from {
      opacity: 0;
      transform: translateY(-4px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`

// ─────────────────────────────────────────────────────────────
// Options list
// ─────────────────────────────────────────────────────────────

export const CountryList = styled.div`
  display: flex;
  flex-direction: column;

  gap: 4px;

  max-height: 280px;

  overflow-y: auto;

  padding-right: 2px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: #d1d5db;
    border-radius: 999px;
  }
`

export const CountryOption = styled.button`
  display: block;

  width: 100%;

  padding: 8px 12px;
  text-align: left;

  border-radius: 10px;
  border: 1px solid
    ${({isSelected}) => (isSelected ? '#0049D4' : 'transparent')};

  background: ${({isSelected, isHighlighted}) =>
    isSelected || isHighlighted
      ? 'linear-gradient(180deg,#f1f2ff 88.65%,#fdfdff 100%)'
      : 'transparent'};

  color: ${({isSelected}) => (isSelected ? '#111827' : '#374151')};

  font-size: 12px;
  font-weight: ${({isSelected}) => (isSelected ? 600 : 500)};

  cursor: pointer;

  white-space: normal;
  word-break: break-word;

  transition: background 160ms ease, color 160ms ease;

  &:focus-visible {
    outline: 2px solid #2563eb;
    outline-offset: 2px;
  }
`

export const NoResults = styled.div`
  padding: 10px 12px;

  color: #6b7280;
  font-size: 12px;
`
